import constants from 'constants/index'

const processChipStatusLabel = (status) => {
  return (
    (status && constants.audits.DATA_PROCESS_CHIP_STATUS_LABEL[status]) ||
    'Indefinido'
  )
}

export default processChipStatusLabel
